import { render, staticRenderFns } from "./BtnDeflatorFaseContrato.vue?vue&type=template&id=2544a106&"
import script from "./BtnDeflatorFaseContrato.vue?vue&type=script&lang=js&"
export * from "./BtnDeflatorFaseContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports